// AUTO-GENERATED by docs/tier-map/generate.py — do not edit by hand.
// Source: docs/municipalities-seed.csv

export type RateTier = "A" | "B" | "C" | "D";

export const DEFAULT_TIER_ASSIGNMENTS: Readonly<Record<string, RateTier>> = {
  "Adjuntas": "B",
  "Arecibo": "A",
  "Cabo Rojo": "B",
  "Cataño": "B",
  "Ceiba": "C",
  "Culebra": "D",
  "Fajardo": "C",
  "Florida": "B",
  "Hormigueros": "A",
  "Maunabo": "C",
  "Mayagüez": "A",
  "Ponce": "B",
  "San Juan": "B",
  "Toa Alta": "B",
  "Utuado": "B",
  "Cidra": "B",
  "Coamo": "C",
  "Comerío": "B",
  "Corozal": "B",
  "Dorado": "B",
  "Guánica": "B",
  "Aguada": "A",
  "Aguadilla": "A",
  "Aguas Buenas": "B",
  "Aibonito": "C",
  "Añasco": "A",
  "Arroyo": "C",
  "Barceloneta": "B",
  "Barranquitas": "B",
  "Bayamón": "B",
  "Caguas": "B",
  "Camuy": "A",
  "Canóvanas": "B",
  "Carolina": "B",
  "Cayey": "C",
  "Ciales": "B",
  "Luquillo": "C",
  "Manatí": "B",
  "Maricao": "A",
  "Moca": "A",
  "Morovis": "B",
  "Naguabo": "C",
  "Guayama": "C",
  "Guayanilla": "B",
  "Guaynabo": "B",
  "Gurabo": "B",
  "Hatillo": "A",
  "Humacao": "C",
  "Isabela": "A",
  "Jayuya": "B",
  "Juana Díaz": "C",
  "Juncos": "C",
  "Lajas": "B",
  "Lares": "A",
  "Las Marías": "A",
  "Las Piedras": "C",
  "Loíza": "B",
  "Vega Alta": "B",
  "Vega Baja": "B",
  "Vieques": "D",
  "Villalba": "C",
  "Yabucoa": "C",
  "Naranjito": "B",
  "Orocovis": "B",
  "Patillas": "C",
  "Peñuelas": "B",
  "Quebradillas": "A",
  "Rincón": "A",
  "Río Grande": "C",
  "Sabana Grande": "B",
  "Salinas": "C",
  "San Germán": "A",
  "San Lorenzo": "C",
  "San Sebastián": "A",
  "Santa Isabel": "C",
  "Toa Baja": "B",
  "Trujillo Alto": "B",
  "Yauco": "B",
};
